import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { FilterOperator } from 'lib/ng-data-table/base';
import { DtMessages, DtMessagesEn } from 'lib/dt-translate';

@Component({
  selector: 'app-googlemaplegendpopup',
  templateUrl: './googlemaplegendpopup.component.html',
  styleUrls: ['./googlemaplegendpopup.component.scss']
})
export class GooglemaplegendpopupComponent implements OnInit {

  popupTitle: string = "Legend";
  btnApply: string = "btn btn-primary";
  ApplyOrNot: string = "Apply";
  legendData = [];
  operAndCritList: any[];
  pinType = "Threshold Type";//Threshold, VQuad Call ID, VQuad Device ID, Call Events

  //susheel
  stringOperators: any[];
  rangeOperators: any[];
  messages: DtMessages = new DtMessagesEn({});

  constructor(private http: HttpClient, public dialogBox: MatDialogRef<GooglemaplegendpopupComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.legendData = data.pageValue;
    this.pinType = data.pinType;
  }

  ngOnInit() {
    //susheel
    this.stringOperators = [
      { value: FilterOperator.STARTS_WITH, text: this.messages.startsWith },
      { value: FilterOperator.ENDS_WITH, text: this.messages.endsWith },
      { value: FilterOperator.CONTAINS, text: this.messages.contains },//2 - standard index for old webviewer data
      { value: FilterOperator.NOT_CONTAINS, text: this.messages.notContains },
      { value: FilterOperator.EQUALS, text: this.messages.equals },
      { value: FilterOperator.NOT_EQUAL, text: this.messages.notEqual },
      //{ value: FilterOperator.IS_EMPTY, text: this.messages.isEmpty },
      //{ value: FilterOperator.IS_NOT_EMPTY, text: this.messages.isNotEmpty },
    ];
    this.rangeOperators = [
      { value: FilterOperator.GREATER_THAN_OR_EQUAL, text: this.messages.greaterThanOrEqual },//0 - standard index for old webviewer data
      { value: FilterOperator.LESS_THAN_OR_EQUAL, text: this.messages.lessThanOrEqual },//1 - standard index for old webviewer data
      { value: FilterOperator.EQUALS, text: this.messages.equals },//2 - standard index for old webviewer data
      { value: FilterOperator.NOT_EQUAL, text: this.messages.notEqual },
      { value: FilterOperator.GREATER_THAN, text: this.messages.greaterThan },
      { value: FilterOperator.LESS_THAN, text: this.messages.lessThan },
      //{ value: FilterOperator.IN_RANGE, text: this.messages.inRange },
      //{ value: FilterOperator.IS_EMPTY, text: this.messages.isEmpty },
      //{ value: FilterOperator.IS_NOT_EMPTY, text: this.messages.isNotEmpty },
    ];

    //console.log(this.legendData[0].IsApplied)
    if (this.legendData[0].IsApplied == 1)//susheel
    {
      this.ApplyOrNot = "Revert";
      this.btnApply = "btnApplyColor";
    }
    else {
      this.ApplyOrNot = "Apply";
      this.btnApply = "btn btn-primary";
    }

    if (this.pinType == "Threshold Type") {
      this.legendData.forEach((item) => {
        item["newOperator"] = FilterOperator.GREATER_THAN_OR_EQUAL;
        //Set the type of input - number or string
        item["isValueFilter"] = false;
        item["critNeeded"] = true;

        if (item.Label.indexOf('::true') != -1) {
          item["selParamOperators"] = this.rangeOperators;
          switch (item.OperatorDropDown) {
            case ">=":
              item["newOperator"] = FilterOperator.GREATER_THAN_OR_EQUAL;
              break;
            case "<=":
              item["newOperator"] = FilterOperator.LESS_THAN_OR_EQUAL;
              break;
            case "=":
              item["newOperator"] = FilterOperator.EQUALS;
              break;
            case "NOT EQUALS":
              item["newOperator"] = FilterOperator.NOT_EQUAL;
              break;
            case ">":
              item["newOperator"] = FilterOperator.GREATER_THAN;
              break;
            case "<":
              item["newOperator"] = FilterOperator.LESS_THAN;
              break;
          }
        }
        else {
          item["selParamOperators"] = this.stringOperators;
          item["isValueFilter"] = true;
          item["critNeeded"] = true;
          switch (item.OperatorDropDown) {
            case "STARTS WITH":
              item["newOperator"] = FilterOperator.STARTS_WITH;
              break;
            case "ENDS WITH":
              item["newOperator"] = FilterOperator.ENDS_WITH;
              break;
            case "LIKE":
              item["newOperator"] = FilterOperator.CONTAINS;
              break;
            case "NOT LIKE":
              item["newOperator"] = FilterOperator.NOT_CONTAINS;
              break;
            case "=":
              item["newOperator"] = FilterOperator.EQUALS;
              break;
            case "NOT EQUALS":
              item["newOperator"] = FilterOperator.NOT_EQUAL;
              break;
            case "IS NULL":
              item["newOperator"] = FilterOperator.IS_EMPTY;
              item["critNeeded"] = false;
              break;
            case "IS NOT NULL":
              item["newOperator"] = FilterOperator.IS_NOT_EMPTY;
              item["critNeeded"] = false;
              break;
          }
        }
        //https://dmitripavlutin.com/replace-all-string-occurrences-javascript/
        item["LabelHtml"] = item["Label"].replace(/::true/gi, '').replace(/::false/gi, '');
      });
    }
    else {
      this.operAndCritList = [];
      this.legendData.forEach((item, i) => {
        //debugger
        if (item.Label == "VQuad Device ID" && this.legendData.length == 2 && i == 0) {//call events dev id handled here
          let conditionValue = (item.ConditionValue.split('<font'))[0].trim();
          let defaultStringMatchMode = FilterOperator.STARTS_WITH;
          let value = '';
          let critDisplay = true;
          if (conditionValue.indexOf("STARTS WITH") != -1) {
            defaultStringMatchMode = FilterOperator.STARTS_WITH;
            value = (conditionValue.split("STARTS WITH "))[1];
          }
          else if (conditionValue.indexOf("ENDS WITH") != -1) {
            defaultStringMatchMode = FilterOperator.ENDS_WITH;
            value = (conditionValue.split("ENDS WITH "))[1];
          }
          else if (conditionValue.indexOf("NOT LIKE") != -1) {
            defaultStringMatchMode = FilterOperator.NOT_CONTAINS;
            value = (conditionValue.split("NOT LIKE "))[1];
          }
          else if (conditionValue.indexOf("LIKE") != -1) {
            defaultStringMatchMode = FilterOperator.CONTAINS;
            value = (conditionValue.split("LIKE "))[1];
          }
          else if (conditionValue.indexOf("=") != -1) {
            defaultStringMatchMode = FilterOperator.EQUALS;
            value = (conditionValue.split("= "))[1];
          }
          else if (conditionValue.indexOf("NOT EQUALS") != -1) {
            defaultStringMatchMode = FilterOperator.NOT_EQUAL;
            value = (conditionValue.split("NOT EQUALS "))[1];
          }
          else if (conditionValue.indexOf("IS NULL") != -1) {
            defaultStringMatchMode = FilterOperator.IS_EMPTY;
            value = (conditionValue.split("IS NULL "))[1];
            critDisplay = false;
          }
          else if (conditionValue.indexOf("IS NOT NULL") != -1) {
            defaultStringMatchMode = FilterOperator.IS_NOT_EMPTY;
            value = (conditionValue.split("IS NOT NULL "))[1];
            critDisplay = false;
          }

          this.operAndCritList.push({ id: item.Label, oper: defaultStringMatchMode, critVal: value, critInputDisable: false, critInputDisplay: critDisplay, andOr: "AND" });
        }
        else if (this.legendData.length == 1 || item.Label == "Call Control Event" && this.legendData.length == 2 && i > 0) {
          let condVal = item.ConditionValue;
          if (i == 1)
            condVal = (condVal.split('</br>'))[1];//Remove this Dev ID for following call events crit list 
          let conditionValueArr = condVal.split(',');
          let idVal = 1;
          conditionValueArr.forEach((conditionValue, critIndx) => {
            let defaultStringMatchMode = FilterOperator.STARTS_WITH;
            let critDisplay = true;
            let value = '';
            if (conditionValue.indexOf("STARTS WITH") != -1) {
              defaultStringMatchMode = FilterOperator.STARTS_WITH;
              value = (conditionValue.split("STARTS WITH "))[1];
            }
            else if (conditionValue.indexOf("ENDS WITH") != -1) {
              defaultStringMatchMode = FilterOperator.ENDS_WITH;
              value = (conditionValue.split("ENDS WITH "))[1];
            }
            else if (conditionValue.indexOf("NOT LIKE") != -1) {
              defaultStringMatchMode = FilterOperator.NOT_CONTAINS;
              value = (conditionValue.split("NOT LIKE "))[1];
            }
            else if (conditionValue.indexOf("LIKE") != -1) {
              defaultStringMatchMode = FilterOperator.CONTAINS;
              value = (conditionValue.split("LIKE "))[1];
            }
            else if (conditionValue.indexOf("=") != -1) {
              defaultStringMatchMode = FilterOperator.EQUALS;
              value = (conditionValue.split("= "))[1];
            }
            else if (conditionValue.indexOf("NOT EQUALS") != -1) {
              defaultStringMatchMode = FilterOperator.NOT_EQUAL;
              value = (conditionValue.split("NOT EQUALS "))[1];
            }
            else if (conditionValue.indexOf("IS NULL") != -1) {
              defaultStringMatchMode = FilterOperator.IS_EMPTY;
              value = "";
              critDisplay = false;
            }
            else if (conditionValue.indexOf("IS NOT NULL") != -1) {
              defaultStringMatchMode = FilterOperator.IS_NOT_EMPTY;
              value = "";
              critDisplay = false;
            }

            let currAndOr = "";
            if (critIndx < conditionValueArr.length - 1)
              currAndOr = "OR";
            this.operAndCritList.push({ id: item.Label + (idVal++), oper: defaultStringMatchMode, critVal: value, critInputDisable: false, critInputDisplay: critDisplay, andOr: currAndOr });
          });
        }
      });
      //console.log(this.operAndCritList)
    }

    //console.log(this.legendData)
  }


  ClosePopup() {
    this.dialogBox.close();
  }
  ApplyPopup() {
    this.legendData.forEach((item) => {
      this.validateCriteria(item.Text, item.isValueFilter, item.critNeeded);
      item["critErrorDesc"] = this.critErrorDesc;
    });

    if (this.critErrors == true)
      return false;

    let newCondVal = "";
    if (this.pinType == "Threshold Type") {
      this.legendData.forEach((item, indx) => {
        if (item["isValueFilter"] == false) {
          switch (item["newOperator"]) {
            case FilterOperator.GREATER_THAN_OR_EQUAL:
              item.OperatorDropDown = ">=";
              item["newOperatorIndex"] = 0;
              break;
            case FilterOperator.LESS_THAN_OR_EQUAL:
              item.OperatorDropDown = "<=";
              item["newOperatorIndex"] = 1;
              break;
            case FilterOperator.EQUALS:
              item.OperatorDropDown = "=";
              item["newOperatorIndex"] = 2;
              break;
            case FilterOperator.NOT_EQUAL:
              item.OperatorDropDown = "NOT EQUALS";
              item["newOperatorIndex"] = 3;
              break;
            case FilterOperator.GREATER_THAN:
              item.OperatorDropDown = ">";
              item["newOperatorIndex"] = 4;
              break;
            case FilterOperator.LESS_THAN:
              item.OperatorDropDown = "<";
              item["newOperatorIndex"] = 5;
              break;
          }
        }
        else {
          switch (item["newOperator"]) {
            case FilterOperator.STARTS_WITH:
              item.OperatorDropDown = "STARTS WITH";
              item["newOperatorIndex"] = 0;
              break;
            case FilterOperator.ENDS_WITH:
              item.OperatorDropDown = "ENDS WITH";
              item["newOperatorIndex"] = 1;
              break;
            case FilterOperator.CONTAINS:
              item.OperatorDropDown = "LIKE";
              item["newOperatorIndex"] = 2;
              break;
            case FilterOperator.NOT_CONTAINS:
              item.OperatorDropDown = "NOT LIKE";
              item["newOperatorIndex"] = 3;
              break;
            case FilterOperator.EQUALS:
              item.OperatorDropDown = "=";
              item["newOperatorIndex"] = 4;
              break;
            case FilterOperator.NOT_EQUAL:
              item.OperatorDropDown = "NOT EQUALS";
              item["newOperatorIndex"] = 5;
              break;
            case FilterOperator.IS_EMPTY:
              item.OperatorDropDown = "IS NULL";
              item["newOperatorIndex"] = 6;
              break;
            case FilterOperator.IS_NOT_EMPTY:
              item.OperatorDropDown = "IS NOT NULL";
              item["newOperatorIndex"] = 7;
              break;
          }

          newCondVal += item.Label + ' ' + item.OperatorDropDown + ' ' + item.Text;//susheel
          if (indx <= this.legendData.length - 1) {
            if (item.AndORDropDown == 'AND' || item.AndORDropDown == null)//null for VQuuad Dev ID, if there in cond
              newCondVal += '  <font style=color:green>AND</font></br>  ';
            else
              newCondVal += '  <font style=color:red>OR</font></br>  ';
          }
        }
      });

      this.legendData.forEach(item => { item.ConditionValue = newCondVal });
    }
    else {
      let currCritListValue = "";
      this.operAndCritList.forEach((eachOperAndCrit, indx) => {
        if (eachOperAndCrit.critVal.trim().length > 0 || eachOperAndCrit.critInputDisable == true || eachOperAndCrit.oper == FilterOperator.IS_EMPTY || eachOperAndCrit.oper == FilterOperator.IS_NOT_EMPTY) {
          let operNew = "=";
          if (eachOperAndCrit.oper == FilterOperator.EQUALS) {
            currCritListValue += '*' + eachOperAndCrit.critVal.trim() + '*';
            operNew = "=";
          }
          else if (eachOperAndCrit.oper == FilterOperator.NOT_EQUAL) {
            currCritListValue += '^' + eachOperAndCrit.critVal.trim() + '^';
            operNew = "NOT EQUALS";
          }
          else if (eachOperAndCrit.oper == FilterOperator.STARTS_WITH) {
            currCritListValue += eachOperAndCrit.critVal.trim() + '%';
            operNew = "STARTS WITH";
          }
          else if (eachOperAndCrit.oper == FilterOperator.ENDS_WITH) {
            currCritListValue += '%' + eachOperAndCrit.critVal.trim();
            operNew = "ENDS WITH";
          }
          else if (eachOperAndCrit.oper == FilterOperator.NOT_CONTAINS) {
            currCritListValue += '!' + eachOperAndCrit.critVal.trim() + '!';
            operNew = "NOT LIKE";
          }
          else if (eachOperAndCrit.oper == FilterOperator.CONTAINS) {
            currCritListValue += eachOperAndCrit.critVal.trim();
            operNew = "LIKE";
          }
          else if (eachOperAndCrit.oper == FilterOperator.IS_NOT_EMPTY) {
            operNew = "IS NOT NULL";
          }
          else if (eachOperAndCrit.oper == FilterOperator.IS_EMPTY) {
            operNew = "IS NULL";
          }

          //console.log(eachOperAndCrit.id + '::' + indx)
          //debugger
          if (eachOperAndCrit.id == "VQuad Device ID" && this.legendData.length == 2 && indx == 0) { //call events dev id handled here
            newCondVal += eachOperAndCrit.id + ' ' + operNew + ' ' + eachOperAndCrit.critVal.trim() + '  <font style=color:green>AND</font></br>  ';
            currCritListValue = currCritListValue + '$';
          }
          else if (this.legendData.length == 1 || eachOperAndCrit.id.indexOf("Call Control Event") != -1 && this.legendData.length == 2 && indx > 0) {
            newCondVal += eachOperAndCrit.id + ' ' + operNew + ' ' + eachOperAndCrit.critVal.trim();//susheel
            if (indx <= this.operAndCritList.length - 1) {
              newCondVal += ',';

              currCritListValue += '|';
            }
          }
        }
      });

      currCritListValue = currCritListValue.substring(0,  currCritListValue.length - 1);
      this.legendData[0]["currCritListValue"] = currCritListValue;
      this.legendData.forEach(item => { item.ConditionValue = newCondVal });
    }

    //console.log(this.legendData)

    this.legendData[0].IsApplied = this.legendData[0].IsApplied == 0 ? 1 : 0;//susheel
    //console.log(this.legendData[0].IsApplied)
    this.dialogBox.close(this.legendData);
  }


  //onKeyPressFilterInput(event: KeyboardEvent) {
  //  if (event.which === Keys.ENTER) {
  //    //this.onClickOk();
  //  }
  //}

  //When oper selected as Is Empty or Is Not Empty then no need of crit input-susheel
  onThresholdModeChange(item) {
    //console.log(isValueFilter + "::" + this.value)
    item["critNeeded"] = true;
    if (item.newOperator == FilterOperator.IS_EMPTY || item.newOperator == FilterOperator.IS_NOT_EMPTY) {
      item["critNeeded"] = false;
    }
  }
  onNonThresholdModeChange(item) {
    //console.log(isValueFilter + "::" + this.value)
    item["critNeeded"] = true;
    if (item.oper == FilterOperator.IS_EMPTY || item.oper == FilterOperator.IS_NOT_EMPTY) {
      item["critNeeded"] = false;
    }
  }


  critErrors: boolean = false;
  critErrorDesc = "";
  validateCriteria(mainValue: any, isValueFilter: boolean, critNeeded: boolean) {
    this.critErrorDesc = "";

    //when input empty
    if (mainValue.length === 0 && critNeeded == true) {
      this.critErrors = true;
      this.critErrorDesc = "*Required";
    }
    else if (this.pinType == "Threshold Type" && !isValueFilter) {//when input type is numeric and pasted alpha numeric with threshold type
      if (isNaN(mainValue)) {
        this.critErrors = true;
        this.critErrorDesc = "*Invalid number";
      }
    }
  }


  //andOrs: SelectItem[] = [
  //  { id: 1, name: 'AND' },
  //  { id: 2, name: 'OR' },
  //];
  //selectedAndOrs: number[] = [1];

  //onAndOrChange(event) {
  //  let selID = parseInt(event);
  //  this.selectedAndOrs = [selID];
  //}
}
